import React from 'react'
import { MdSend } from 'react-icons/md'

const ExpenseForm = ({
  charge,
  mount,
  handleCharge,
  handleSubmit,
  handleAmount,
  edit,
 
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className='form-center'>
        <div className='form-group'>
          <label htmlFor='charge'>charge</label>
          <input
            type='text'
            className='form-control'
            id='charge'
            name='charge'
            placeholder='e.g rent'
            value={charge}
            onChange={handleCharge}
          />
        </div>
        <div className='form-group'>
          <label htmlFor='mount'>mount</label>
          <input
            type='number'
            className='form-control'
            id='mount'
            name='mount'
            placeholder='e.g mount'
            value={mount}
            onChange={handleAmount}
          />
        </div>
      </div>
      <button type='submit' className='btn'>
        {edit ? "edit" :"submit"}
        <MdSend className='btn-icons' />
      </button>
    </form>
  )
}

export default ExpenseForm
